var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5571946(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 366.55 396.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-15,.cls-16,.cls-17,.cls-19,.cls-21,.cls-25,.cls-29,.cls-6{fill:none;}.cls-2{fill:#80ade2;}.cls-3{isolation:isolate;}.cls-4{fill:#eae7da;}.cls-5{fill:#eec555;}.cls-20,.cls-21,.cls-6{stroke:#eec555;}.cls-16,.cls-20,.cls-25,.cls-6{stroke-miterlimit:10;}.cls-6{stroke-width:3px;}.cls-7{fill:#75a6df;}.cls-8{fill:#689edc;}.cls-20,.cls-9{fill:#e4a33a;}.cls-10{fill:#383a39;}.cls-11{fill:#5b95d9;}.cls-12{fill:#8ab3e4;}.cls-13{fill:#57944f;}.cls-14{fill:#2b5886;}.cls-15,.cls-16{stroke:#f2f0e8;}.cls-15,.cls-16,.cls-17,.cls-19,.cls-21,.cls-29{stroke-linecap:round;}.cls-15,.cls-17,.cls-19,.cls-21,.cls-29{stroke-linejoin:round;}.cls-15,.cls-25{stroke-width:3.46px;}.cls-16{stroke-width:6.92px;stroke-dasharray:0 6.92;}.cls-17{stroke:#5483d7;stroke-width:2px;}.cls-18{fill:#957edf;}.cls-19{stroke:#383a39;stroke-width:5px;}.cls-20,.cls-21{stroke-width:1.73px;}.cls-22{fill:#c52900;}.cls-23,.cls-26{fill:#de764e;}.cls-24{clip-path:url(#clip-path);}.cls-25{stroke:#e4a33a;}.cls-26{opacity:0.5;mix-blend-mode:multiply;}.cls-27{fill:#e59c7b;}.cls-28{fill:#f2f0e8;}.cls-29{stroke:#ded9c4;}.cls-30{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-57.81 -34.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.06,262.9c-44,0-79.63,32.51-79.63,72.63s35.65,72.63,79.63,72.63,79.63-32.52,79.63-72.63S281,262.9,237.06,262.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-57.81 -34.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.29,384.61c-18.12.9-41.1-.71-44.18,7.78-2.09,5.77,2.22,9.78,5.71,8.75-4.18,4.62-5.14,11.81,4.57,26.46,8.43,8.51,35.06-1.9,43.65-5.67C279.13,413.54,273.82,383.43,250.29,384.61Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 183.28,
    cy: 372.16,
    rx: 183.28,
    ry: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 145.38,
    cy: 96.06,
    r: 78.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 145.38,
    cy: 96.06,
    r: 94.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.1,306.59c-32.09,15.17-32,53.67-39.54,87.12,8.43,13.27,23.5,13.8,34.86,9.79,14.65-20.43,34.15-38.89,32.27-71.26C169.37,309.55,159.57,298.8,143.1,306.59Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.5,342.41a82.8,82.8,0,0,1,13.76,21.37,81.85,81.85,0,0,1,4.59,14.83c8.5-12.77,15-27.1,13.84-46.37-1.32-22.69-11.12-33.44-27.59-25.65a48.86,48.86,0,0,0-21.19,19.11A195.22,195.22,0,0,1,138.5,342.41Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M122,381.53s-31.92-1-35.33-1.67c-7-1.21-9-2.41-12.43-4.69-5.48-3.65-11.64,7.16-4.47,10.37,6.13,4.06,6.21,5.95,10.94,9.54s8.46,5.14,16.26,10.45c7.28,5,14,14.74,17.54,17.43,7.09,5.37,21.57-3.38,23.93-17.53C139.72,398,140.78,388.56,122,381.53Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142,405.8a3.47,3.47,0,0,1-3.39-2.74c-3-14.27-20.89-21.67-32-22.17a3.46,3.46,0,0,1,.31-6.92c13.68.62,34.67,9.61,38.49,27.65a3.48,3.48,0,0,1-2.67,4.11A3.58,3.58,0,0,1,142,405.8Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M330.34,178.37c-1.76-6-7.37-10.73-13.76-12.19a18,18,0,0,0,1.23-4c2.35-12-6-25.07-18.3-28.69.91-12.09-7.09-27.36-18-33.67s-24.2-8-37-7.58c-27.6,1-50.2,18.63-76.82,25.59-10.34,2.71-18.86,10.92-21.53,20.76a28.56,28.56,0,0,0,8.31,28c-6.76-.75-11.21,1.43-14.41,7.11a15.85,15.85,0,0,0,2.09,18.08c-6-.39-11.22,6.37-10.92,12s6.51,10.38,12.41,9.43c-2.27,5-.62,8.75,3.14,12.94,7.09,7.89,19,10.58,29.92,9.4s21-5.67,30.88-10.09c3.94,10.38,14.44,15.39,25.87,13.28,9.72-1.79,66.12-7.85,69.91-8,8.91-.26,17.36-6,20.45-13.93A20.89,20.89,0,0,0,321.53,198C328.55,194.25,332.5,185.78,330.34,178.37Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M185.79,257.31c7.12-39.5,22.82-52.33,61.82-48.46S299.3,224.51,306.09,263c2.33,13.24,6.61,48.48,5.68,61.33-3.35,46.79-130.07,46.71-132.78-1.61C178,304.74,182.5,275.59,185.79,257.31Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M308,383c31.4,1.73,54,5.71,58.73-4.81,8-20.87-11.21-36.44-38.2-49.94C294.72,311.3,249.49,300,239,335,228.8,369.18,261.75,380.42,308,383Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M148.35,255.37c-19,18.76-26.13,39.32-15.41,51.15,16.33,18,31.67.91,50.67-17.85s42.84-38.18,27.35-56.94C190.42,206.85,167.36,236.61,148.35,255.37Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.17,256.72c14.22,18,17.05,37.19,4.89,47.52-18.53,15.74-29.64-.62-43.87-18.66s-32.81-36.91-14.92-53.37C302,210.38,318,238.68,332.17,256.72Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M292.63,269.18a3.42,3.42,0,0,1-2.16-.75,3.47,3.47,0,0,1-.55-4.87,59.82,59.82,0,0,1,34.29-21.11,3.46,3.46,0,0,1,1.43,6.77,53.63,53.63,0,0,0-30.31,18.66A3.43,3.43,0,0,1,292.63,269.18Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M247,247.13c-11.08,0-25.06-5.93-38-28.59a3.46,3.46,0,1,1,6-3.44c10.82,19,23.73,27.44,37.32,24.53,15.39-3.3,28.77-20.94,30-33.92a3.46,3.46,0,1,1,6.89.67c-1.5,15.62-17,36.06-35.45,40A32.34,32.34,0,0,1,247,247.13Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M148.35,255.37c8-7.66,24.09-16.69,33.55-5.68,17.36,20.18,13.7,82.63,38.3,102.18,51.38,40.82,129.59-68.88,152.12,27.85,3.68,15.8,19.54,29.25,35.61,26.67-4.36-9.94-.72-23,8-29.5-19.78-6.6-25.08-19.25-25.23-31.16-.68-52.39-57.08-64.48-99.58-48.42-12.72,4.7-20.43,8.72-33.94,2.35C232.12,283,251.28,240.57,223.93,224,196.25,201.43,149.76,223.93,148.35,255.37Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M407.55,388.85a86.08,86.08,0,0,1-9-4.05c-7-3.7-14.27-8.34-19.46-14.41-4.45-5.2-7-11.18-9.54-17.49-2.25-5.62-4.54-11.07-9.27-15.09-4.36-3.71-9.91-5.53-15.41-6.73-14.36-3.13-29.52-2.86-43.43,2.06-14.15,5-28,14.82-43.7,13.13-12.79-1.38-23.48-11-31.14-20.69a86.74,86.74,0,0,1-16.88-34.26c-2.76-11.92-2.65-24.5-6.75-36.12C199,244,189.09,235.4,177.11,234.36a45.38,45.38,0,0,0-23.37,4.09,35.23,35.23,0,0,0-5.39,16.92c8-7.66,24.09-16.69,33.55-5.68,17.36,20.18,13.7,82.63,38.3,102.18,51.38,40.82,129.59-68.88,152.12,27.85,3.68,15.8,19.54,29.25,35.61,26.67A24.53,24.53,0,0,1,407.55,388.85Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M174.42,181.87c-1.18-9.35-3.1-25.82.47-50.66,4-28.15,32.44-54.05,67.68-54.45s64.22,24.87,68.89,52.92c4.13,24.75-.36,29.35,1.47,38.6,7.95,40.09-11.89,60.51-52.72,61C214.35,229.76,179.94,225.78,174.42,181.87Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M280.49,178.8c-3.86,9.48-9.53,15.39-15,15.65s-10.5-7-13.51-16.13",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M256.06,122.7c-.93,17.81,2,26.61,10.51,26.61,11.05,0,9.85-12.51,9.85-28.21",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M178.13,171.5a12.3,12.3,0,0,0,11.51-21.71c9.34-6.83,16.59-16.6,16.92-28.17,15.6,1.45,31.73-3.22,41.43-15.51,4.36-5.52,13.07-5.62,18.48-1.14,3.16,2.62,6.89,6.72,3.27,12.75a15.36,15.36,0,0,1-18.39,6.08c5.35,6.62,18.25,12.92,26.32,10.21s12.65-7,12.92-15.49c1.91,1.76,5.37,2,7.28,3.71,4.52,4.18,7.93,9.86,13.59,7.45,9.12-5.33,2.56-31.37-10.15-32.8,3.6-15.82-16-40.34-37.06-29.24-4.66-11.53-18.62-11.57-25.07-2.38C224.4,60,201.42,61.61,196.25,83.74c-6.83-5-29.36,9.78-20.06,23.93-10.64,8.79-14.87,29.68-7.93,41.62C166.44,156.86,171.07,168.22,178.13,171.5Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M176.3,159.57c2.1-69.4,88.35-91.28,132.93-58.38",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.09,172.68c-7.56-28.67-29.54-16.23-30.81-4.12s6.43,30,30.69,20.73Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M183.76,180.66c-2.94-6.34-8.34-12-15.4-16.25",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M179.89,174.31a30,30,0,0,0-9.14-.76",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 219.18,
    cy: 184.63,
    r: 17.12,
    transform: "translate(-123.16 184.24) rotate(-46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M307.46,166.52a16.82,16.82,0,0,1,5.33.87c0,.29.08.58.14.89,2.48,12.47,2.25,23-.45,31.7a16.88,16.88,0,0,1-4.64.77,17.12,17.12,0,0,1-.38-34.23Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M263.18,163.7c4.89-5,12,3.55,5.13,7.17",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M240.57,156.75c-.06,4.49-2.94,8.09-6.43,8.05s-6.28-3.73-6.22-8.22,2.94-8.1,6.43-8.05S240.63,152.25,240.57,156.75Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M298.3,157.5c-.06,4.49-2.94,8.09-6.43,8.05s-6.28-3.73-6.22-8.22,2.94-8.1,6.43-8.05S298.36,153,298.3,157.5Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M217.29,145.85c5.9-5.35,15.94-8.48,27-4.68",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M315.85,145.85c-5.9-5.35-15.93-8.48-27-4.68",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M188.89,73.82a24.54,24.54,0,0,1-34.7,34.71C137.12,91.46,143.46,63.1,143.46,63.1S173,58,188.89,73.82Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M188.89,76.35a22.75,22.75,0,1,1-32.18,32.18c-15.83-15.83-9.94-42.13-9.94-42.13S174.18,61.63,188.89,76.35Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M188.89,79a20.86,20.86,0,0,1-29.49,29.5c-14.51-14.5-9.11-38.61-9.11-38.61S175.41,65.55,188.89,79Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M185,80.05a17.35,17.35,0,0,1-24.53,24.54c-2.33-2.33-4.48-7.38-6.29-13A14.17,14.17,0,0,1,172,73.76C177.57,75.58,182.62,77.72,185,80.05Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M171.78,78.05a10.63,10.63,0,0,0-13.37,13.36c1.36,4.22,3,8,4.72,9.76A13,13,0,0,0,177.24,104c-.74-.85-1.5-1.69-2.23-2.54a4.32,4.32,0,0,1,0-6c1.62-1.77,4.3-1.44,6,0,1,.82,1.88,1.65,2.82,2.48a13,13,0,0,0-2.27-15.22C179.78,81,176,79.41,171.78,78.05Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 203.28,
    cy: 120.55,
    r: 25.7,
    transform: "translate(-19 255.71) rotate(-76.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M206.31,110.49c1.32-4.16,3.35-10.34-2.94-10.34s-4.26,6.18-2.94,10.34",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M198.31,111.29c-2-3.87-4.95-9.68-9.39-5.23s1.36,7.38,5.23,9.39",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M193.22,117.52c-4.16-1.32-10.34-3.35-10.34,2.94s6.18,4.26,10.34,2.94",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M194,125.52c-3.87,2-9.68,5-5.23,9.39s7.38-1.36,9.39-5.23",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M200.25,130.61c-1.32,4.16-3.35,10.34,2.94,10.34s4.26-6.18,2.94-10.34",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M208.25,129.8c2,3.88,4.95,9.68,9.39,5.24s-1.36-7.39-5.23-9.39",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M213.34,123.58c4.16,1.32,10.34,3.35,10.34-2.94s-6.18-4.26-10.34-2.94",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M212.53,115.58c3.88-2,9.68-5,5.24-9.39s-7.39,1.36-9.39,5.23",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 203.28,
    cy: 120.55,
    r: 9.94,
    transform: "translate(-22.2 252.55) rotate(-75.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 145.47,
    cy: 86,
    r: 4.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M237.06,262.9c-44,0-79.63,32.51-79.63,72.63s35.65,72.63,79.63,72.63,79.63-32.52,79.63-72.63S281,262.9,237.06,262.9Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M156.33,327.23c12.93,4.11,4.77,33.76,20.06,37.37,15.37,3.1,20.31-27.26,33.67-25.6,13.38,1.2,11.8,31.93,27.4,32.16,15.61-.27,13.93-31,27.31-32.24,13.35-1.69,18.39,28.65,33.76,25.5,15.3-3.65,7-33.29,20-37.44",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M184.6,348.39A5.6,5.6,0,0,1,173.69,346a5.61,5.61,0,0,1,10.91,2.43Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M212.62,361.19c-.23,2.85-3.06,4.93-6.28,4.57s-5.53-3-5.14-5.83a5.79,5.79,0,0,1,11.42,1.26Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M242,353.56a5.57,5.57,0,0,1-11.11,0,5.57,5.57,0,0,1,11.11,0Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M272.06,360.05c.37,2.83-1.94,5.46-5.16,5.81s-6-1.75-6.26-4.59a5.78,5.78,0,0,1,11.42-1.22Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M299.22,346.26a5.6,5.6,0,0,1-10.92,2.38,5.61,5.61,0,0,1,10.92-2.38Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M330.25,346c1,2.67-.74,5.76-3.84,6.81s-6.33-.38-7.18-3.11a5.86,5.86,0,0,1,11-3.7Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M154.89,349.72c-.85,2.73-4.06,4.16-7.17,3.11s-4.83-4.13-3.85-6.81a5.57,5.57,0,0,1,7.14-3C154,344,155.74,347,154.89,349.72Z",
    transform: "translate(-57.81 -34.55)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M295.48,286.19a67.2,67.2,0,0,1,7.94,31.64c0,40.11-35.65,72.63-79.63,72.63-23.09,0-43.88-9-58.42-23.29,12.89,24.26,40.15,41,71.69,41,44,0,79.63-32.52,79.63-72.63C316.69,316.48,308.64,299.15,295.48,286.19Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M237.06,309.58c-25.22,0-52-8.75-52-25s26.8-25,52-25,52,8.75,52,25S262.28,309.58,237.06,309.58Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M237.06,264.86c25.86,0,46.83,8.85,46.83,19.76s-21,19.77-46.83,19.77-46.83-8.85-46.83-19.77,21-19.76,46.83-19.76m0-10.39c-13.86,0-27.06,2.35-37.15,6.61-17.46,7.37-20.07,17.91-20.07,23.54s2.61,16.18,20.07,23.55c10.09,4.26,23.29,6.6,37.15,6.6s27.06-2.34,37.15-6.6c17.46-7.37,20.06-17.92,20.06-23.55s-2.6-16.17-20.06-23.54c-10.09-4.26-23.29-6.61-37.15-6.61Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M305.76,321.47c.2-1.46.39-2.93.59-4.4a12.36,12.36,0,0,0-1.43-6.37A8.3,8.3,0,0,0,302.8,307a12.55,12.55,0,0,0-4.65-4.26l-1.08-.46a20.75,20.75,0,0,0,1.23-6.9v-.26a23,23,0,0,0-6.06-14.63,15.49,15.49,0,0,0-6.66-4.28,16.19,16.19,0,0,0-2.86-1.13,15,15,0,0,0-1.56-4.87,10,10,0,0,0-2.58-4.43,19.85,19.85,0,0,0-8-6.18,15.15,15.15,0,0,0-7.26-1.72,19.68,19.68,0,0,0-18.59,9.72,19.27,19.27,0,0,0-1.64,3.58,9.3,9.3,0,0,0-4.23,2.11c-1-1.32-1.94-2.62-3-3.87l-.87-1a15.49,15.49,0,0,0-6.66-4.28,18.73,18.73,0,0,0-15.94,0,15.49,15.49,0,0,0-6.66,4.28l-3.24,4.19a20.58,20.58,0,0,0-2.66,8.06,20.56,20.56,0,0,0-14.56,14.32,19.51,19.51,0,0,0,0,10.34,29.73,29.73,0,0,0,1.93,4.59,19.8,19.8,0,0,0,2.09,2.84c.32.39.64.79,1,1.15a26.24,26.24,0,0,0,9.91,6.22,15.31,15.31,0,0,0,8.05.36,15.08,15.08,0,0,0,7.51-2.4l4.09-3.16a19.2,19.2,0,0,0,2.8-3.54,2.71,2.71,0,0,1,4.35-.36c.24.26.48.52.74.76a22.17,22.17,0,0,0,19.83,5.8,10.09,10.09,0,0,0,1.31,2.47,11.42,11.42,0,0,0,.81,12c-.13.27-.3.7-.42,1a7.89,7.89,0,0,0-.3.94,10.3,10.3,0,0,0,.15,5.64,13,13,0,0,0,6.83,7.88,16.46,16.46,0,0,0,10.21,1.46,10.12,10.12,0,0,0,1.07,3,8.1,8.1,0,0,0,3.58,3.37,9.77,9.77,0,0,0,4.86,1.07,9.12,9.12,0,0,0,5.07-1.82,9.72,9.72,0,0,0,3.23-4.78,5,5,0,0,0,.12-.53,10,10,0,0,0,3.5.64c9.67,0,12.27-10.95,7.82-16.89.77-.32,1.55-.64,2.31-1,.13-.08,3.13-2.39,3.24-2.49l.08-.09c.23-.23,2.32-2.94,2.47-3.2a.67.67,0,0,0,.06-.12s.06-.12.12-.25.14-.18.19-.29l.08-.1-.24.32a.69.69,0,0,1,.05-.13A12.48,12.48,0,0,0,305.76,321.47Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M242.11,275.27c2.22-2.75,6.76-2.84,9.55-.66s3.87,6,3.4,9.55",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M255.87,279.14a5.89,5.89,0,0,1,9.85,4.72",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M275.27,272.6c2.55-.7,5.25,1.26,6.26,3.71s.76,5.22.39,7.85",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M294.21,298.06a10.38,10.38,0,0,1,2.8,12.87",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M295.41,326.12a9.68,9.68,0,0,1-6.22,11.16",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M242.15,312.68a11.55,11.55,0,0,0,17.12-.05",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M198,291a11.35,11.35,0,0,1,12-13.15",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M210.53,286.91a10.31,10.31,0,0,1,9.37-11.38",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M214.8,298.78A11.6,11.6,0,0,1,231,292",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M229,286.66a7.38,7.38,0,0,1,8.84-3.5",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M270.21,305.6a6.93,6.93,0,0,1,7.16,9.55",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M283.86,311.52a3.83,3.83,0,0,1,3.57,5.23",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M255.48,299a7.68,7.68,0,0,1,10-2",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M263.15,330.14a6.32,6.32,0,0,0,6.05,6.6",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M272.84,333.2a7.21,7.21,0,0,0,3.39,7.9",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M281.08,328.08a4,4,0,0,1,3.7,6.05",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M253.26,327.85a6,6,0,0,0-.17,9.53",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M264.42,345.79a10.37,10.37,0,0,0,9.86,2.65",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M190,303.84a6,6,0,0,1,9.62-5.21",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M199.43,311.94a8.46,8.46,0,0,1,7.83-10.43",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M211.06,309.66a3,3,0,0,1,4-2.69",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M140.32,316.5c-18.36-13.83-17.23-33.75-1.76-46.89,5.59-4.75,19.08-3.53,34.42,5.91,13.05,8,15.2,19.75,52.11,34.16L215,335.44C200.21,339.87,154.64,327.28,140.32,316.5Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M177.9,327.36c-4.57-2.15-9-4.66-13.33-7.15-3.67-2.09-7.3-4.26-10.82-6.61-7-4.7-13.76-10.14-18.63-17.13a32.76,32.76,0,0,1-5.8-15.08c-5.43,11.6-2.44,25,11,35.11,11,8.29,40.47,17.64,60.25,19.51A165.09,165.09,0,0,1,177.9,327.36Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M249.59,327.24a30.27,30.27,0,0,1,12.19,5.83c3,2.46,1.4,7.36-4.72,6.77A29,29,0,0,1,250,338l-16.5-.12-2.16-12.17S245.59,326.24,249.59,327.24Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M246.1,336.27a26.74,26.74,0,0,1,7.81,9.11c1.62,3.19-1,7.21-5.59,4.8a23.13,23.13,0,0,1-5-3.85l-12.78-5.17,1.78-11.88S243.27,334.13,246.1,336.27Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M258,318.37a28.83,28.83,0,0,1,12,5.74c2.91,2.44,1.13,7.35-5,6.81a27.52,27.52,0,0,1-7-1.78H241.45L239.74,317S254,317.41,258,318.37Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M252.18,308.09a29,29,0,0,1,12.81,3.5c3.29,1.89,2.42,7-3.68,7.59a28.18,28.18,0,0,1-7.2-.49l-16.23,3L234,310S248.1,307.85,252.18,308.09Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M213.45,309.43c23.13-3.75,37.38,1.94,38.08,11.33.58,7.76-5.68,16.63-10.75,19.78-14.91,9.22-30.1-1.35-33.78-5.88",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366,379c-14.68,32.32-68.21,32.16-101.54,40.24-13.39-8.21-14.15-23.28-10.32-34.7,20.21-15,53.4-34.12,85.79-32.74C362.64,352.78,373.53,362.42,366,379Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M365.24,370.16a48.34,48.34,0,0,1-9.91,9.62c-6.58,5.06-13.78,9.18-21,13.3q-14.85,8.52-30,16.43L297,413.33c28.49-4.78,58.58-11.34,69-34.32,2.36-5.21,2.91-9.73,1.85-13.51A20.92,20.92,0,0,1,365.24,370.16Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.29,384.61c-18.12.9-41.1-.71-44.18,7.78-2.09,5.77,2.22,9.78,5.71,8.75-4.18,4.62-5.14,11.81,4.57,26.46,8.43,8.51,35.06-1.9,43.65-5.67C279.13,413.54,273.82,383.43,250.29,384.61Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M208.11,412a24.08,24.08,0,0,1,9.44-4.65",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M211.71,419.86l10-4.68",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M214.51,428.21q4.08-2.22,8.15-4.45",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M207.17,402.94A17.71,17.71,0,0,0,220,397.38",
    transform: "translate(-57.81 -34.55)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M265.09,424.77a3.47,3.47,0,0,1-2.86-5.42,23.41,23.41,0,0,0,3.43-18.14c-1.41-6.1-7.47-14.21-13-17.37a3.46,3.46,0,0,1,3.44-6c7.16,4.1,14.47,13.89,16.29,21.83a30.43,30.43,0,0,1-4.45,23.6A3.45,3.45,0,0,1,265.09,424.77Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M295.82,303.08c15.07,16.69,33.53,15,44.66-1.85,6.29-9.52,1.77-16.74-9-30.65-9.55-12.27-20.06-15.55-41.87-49.47l-24.38,13.43C267.46,246.75,284.07,290.05,295.82,303.08Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M338.3,279.9c-1.85-2.78-4.16-5.84-6.86-9.32-8.73-11.21-18.25-14.91-36.46-41.33",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M304.18,288.89A135.87,135.87,0,0,1,272,256.15c6.47,17.2,16.16,38.46,23.8,46.93,13.85,15.35,30.57,15.13,41.82,1.92A108.18,108.18,0,0,1,304.18,288.89Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M294.29,214.63c-1.4-3.4-7.83-3.91-11.17-4.7-1.58-3.17-7.51-9.79-9.12-11-5.75-4.31-20.29,10.34-21.06,19.53-.55,6.58,4.46,9.93,8.8,15.81,5.25,7.13,14.68,4.15,21.22,1.13C292.25,231.1,297.07,221.37,294.29,214.63Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M264,194.48c-2.52-2.59,3.36-8.28,7.36-5.89s10.39,16.61,9.92,21.57L270.52,214C270.44,213.3,267.32,199.42,264,194.48Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M294.29,214.63c-1.4-3.4-7.83-3.91-11.17-4.7a23.12,23.12,0,0,0-2.17-3.29c-1.42-6.24-6.28-16.09-9.55-18-4-2.39-9.88,3.3-7.36,5.89a27.35,27.35,0,0,1,2.49,5.33c-6.16,3.62-13.07,12.39-13.59,18.65-.55,6.58,6.87,14,12.34,19",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M266.88,243.49c-.79,0-1.58,0-2.37-.08a3.46,3.46,0,0,1,.47-6.91,30.56,30.56,0,0,0,26.91-13.11,3.46,3.46,0,1,1,5.73,3.89A37.68,37.68,0,0,1,266.88,243.49Z",
    transform: "translate(-57.81 -34.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M270.22,187.42c-.06-.09-.15-.17-.21-.26a3.68,3.68,0,0,0-.15-.35,4,4,0,0,0-1.39-1.39,1.75,1.75,0,0,0-.29-.18,5.45,5.45,0,0,0-1.08-.41,4,4,0,0,0-1.32-.1,6.32,6.32,0,0,0-1,.11,5.05,5.05,0,0,0-1.07.41,4.4,4.4,0,0,0-.93.67,3.93,3.93,0,0,0-.73.87,2.75,2.75,0,0,0-.28.63.15.15,0,0,0-.05.06l0,0,0,0a6.6,6.6,0,0,0-.33.77l0,.13a2.72,2.72,0,0,0,0,.28,4.22,4.22,0,0,0-2.15.7,4.44,4.44,0,0,0-1,.82,6.52,6.52,0,0,0-.62.82,8.2,8.2,0,0,0-.42,1,4.42,4.42,0,0,0-.08,2.67,4.6,4.6,0,0,0,1.32,2.18,4.82,4.82,0,0,0,1,.74,5.39,5.39,0,0,0,1.23.47,5.1,5.1,0,0,0,1.29.14,4.58,4.58,0,0,0,1.32-.23,4.68,4.68,0,0,0,2.07-1.34,4.78,4.78,0,0,0,.71-1,7.14,7.14,0,0,0,.38-.9,5.6,5.6,0,0,0,.16-1,2.79,2.79,0,0,0,0-.5c0-.08,0-.17-.05-.25a3.24,3.24,0,0,0,.95-.53l.14-.12a2.6,2.6,0,0,0,.64-.13,3.29,3.29,0,0,0,1.43-.83,2.56,2.56,0,0,0,.67-1,2.44,2.44,0,0,0,.27-1.25A3.18,3.18,0,0,0,270.22,187.42Z",
    transform: "translate(-57.81 -34.55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5571946);
export default __webpack_public_path__ + "static/media/5571946.b68c9c1218eca5df667cd23c340281b6.svg";
export { ForwardRef as ReactComponent };